import { render, staticRenderFns } from "./ModalSide.vue?vue&type=template&id=76900f44&lang=html"
import script from "./ModalSide.vue?vue&type=script&lang=js"
export * from "./ModalSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports